import React from "react";
import styled from "styled-components";
//@ts-ignore
import { BlackCoins } from "../../../assets/icons/BlackCoins.jsx";

interface IProps {
  purchaseable: boolean;
  title: string;
  type: string;
  value: string | number;
  price: string | number;
  onClick: () => void;
  icon: string;
}

interface IButtonProps {
  active: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 20px;
  background-color: #1e1e1e;
`;

const Image = styled.img`
  height: 50px;
  min-width: 90px;
  max-width: 90px;
  object-fit: cover;
  border-radius: 15px;
`;

const TitleContainer = styled.div`
  color: white;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
`;

const SubTitle = styled.p`
  font-weight: 300;
  font-size: 14px;
  b {
    font-weight: 700;
  }
`;

const PriceContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const Price = styled.p`
  color: white;
  font-size: 18px;
`;

const Purchase = styled.button<IButtonProps>`
  background-color: ${({ active }) => (active ? "#7515ed" : "#d9d9d922")};
  border: none;
  border-radius: 10px;
  color: white;
  padding: 0 20px;
  cursor: ${({ active }) => (active ? "pointer" : "not-allowed")};
  opacity: ${({ active }) => (active ? 1 : 0.6)};
`;

export const ReferralStoreItem = (props: IProps) => {
  return (
    <Container>
      <Image src={props.icon} />
      <TitleContainer>
        <Title>{props.title}</Title>
        <SubTitle>
          {props.type}{' '}
          {props.type === "Gift Card" && (
            <b>
              {props.value}
              {typeof props.value === "number" ? "R$" : ""}
            </b>
          )}
        </SubTitle>
      </TitleContainer>
      <PriceContainer>
        <BlackCoins />
        <Price>{props.price}</Price>
      </PriceContainer>
      <Purchase
        onClick={() => (props.purchaseable ? props.onClick() : "")}
        active={props.purchaseable}
      >
        Comprar
      </Purchase>
    </Container>
  );
};
